import { RouterModule } from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { AuthGuard } from './auth/auth.guard';
import { Roles } from '@models/roles';
var ɵ0 = {
    roles: [Roles.evaluator, Roles.thirdParty, Roles.candidate, Roles.admin]
}, ɵ1 = {
    roles: [Roles.admin, Roles.candidate]
}, ɵ2 = {
    roles: [Roles.evaluator, Roles.admin, Roles.candidate]
}, ɵ3 = {
    roles: [Roles.evaluator, Roles.admin, Roles.candidate, Roles.thirdParty]
}, ɵ4 = {
    roles: [Roles.evaluator, Roles.admin, Roles.thirdParty]
}, ɵ5 = {
    roles: [Roles.admin, Roles.thirdParty]
}, ɵ6 = {
    roles: [Roles.admin, Roles.evaluator]
}, ɵ7 = {
    roles: [Roles.admin, Roles.candidate]
};
var routes = [
    {
        path: 'dashboard',
        component: MainLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: './dashboard/dashboard.module#DashboardModule'
            }
        ],
        canLoad: [AuthGuard],
        canActivate: [AuthGuard],
        data: ɵ0
    },
    {
        path: 'exam/:examId',
        component: MainLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: './exam/exam.module#ExamModule'
            }
        ],
        canLoad: [AuthGuard],
        data: ɵ1
    },
    {
        path: 'video',
        component: MainLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: './video-conference/video-conference.module#VideoConferenceModule'
            }
        ],
        canLoad: [AuthGuard],
        data: ɵ2
    },
    {
        path: 'profile',
        component: MainLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: './user/user.module#UserModule'
            }
        ],
        canLoad: [AuthGuard],
        data: ɵ3
    },
    {
        path: 'admin',
        loadChildren: './admin/admin.module#AdminModule',
        canLoad: [AuthGuard],
        data: ɵ4
    },
    {
        path: 'third-party',
        loadChildren: './third-party/third-party.module#ThirdPartyModule',
        canLoad: [AuthGuard],
        data: ɵ5
    },
    {
        path: 'evaluator',
        loadChildren: './evaluator/evaluator.module#EvaluatorModule',
        canLoad: [AuthGuard],
        data: ɵ6
    },
    {
        path: 'register/certification',
        loadChildren: './register-certification/register-certification.module#RegisterCertificationModule',
        canLoad: [AuthGuard],
        data: ɵ7
    },
    { path: '**', redirectTo: '/dashboard', pathMatch: 'full' }
];
export var AppRoutes = RouterModule.forRoot(routes, {
    enableTracing: false // <-- debugging purposes only
});
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7 };
